/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyMonitoringDeviceType
 */
export interface ReadOnlyMonitoringDeviceType {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoringDeviceType
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoringDeviceType
     */
    label?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoringDeviceType
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoringDeviceType
     */
    externalId: string;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoringDeviceType
     */
    externalSystem: number;
}

export function ReadOnlyMonitoringDeviceTypeFromJSON(json: any): ReadOnlyMonitoringDeviceType {
    return ReadOnlyMonitoringDeviceTypeFromJSONTyped(json, false);
}

export function ReadOnlyMonitoringDeviceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyMonitoringDeviceType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'externalId': json['external_id'],
        'externalSystem': json['external_system'],
    };
}

export function ReadOnlyMonitoringDeviceTypeToJSON(value?: ReadOnlyMonitoringDeviceType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'name': value.name,
        'external_id': value.externalId,
        'external_system': value.externalSystem,
    };
}


